<template>
    <console-layout width="100%" max-width="1024">

        <console-title>
            <span>운영정보설정</span>
        </console-title>

        <console-body>
            <v-card>
                <v-card-title class="subtitle-2"><b>배송정보</b></v-card-title>
                <v-card-text>
                    <v-select v-model="setting.courierCode" label="택배사" :items="couriers" item-value="code" persistent-placeholder />
                    <v-text-field label="배송추적설정" persistent-placeholder hide-details :value="couriers.find(courier => courier.code == setting.courierCode)?.url" readonly />
                </v-card-text>
            </v-card>
    
            <v-card class="mt-4">
                <v-card-title class="subtitle-2"><b>기본배송정책</b></v-card-title>
                <v-divider/>
                <v-card-text class="pa-0">
                    <v-radio-group v-model="setting.shippingCode" dense hide-details class="pa-0 ma-0">
                        <v-data-table :items="shippings" item-key="code" :headers="shippingsHeaders" disable-sort disable-pagination hide-default-footer>
                            <template slot="item.actions" slot-scope="{item}">
                                <v-radio :value="item.code" />
                            </template>
                            <template slot="item.name" slot-scope="{item}">
                                <v-icon size="16" :color="item.color" class="mr-2">{{ item.icon }}</v-icon>
                                <span class="subtitle-2">{{ item.name }}</span>
                            </template>
                            <template slot="item.shippingPrice" slot-scope="{item}">
                                <v-layout v-if="item.code == 'self'" align="center" class="pa-2">
                                    <v-flex grow-shrink-0>
                                        <v-text-field v-model="setting.shippingPrice.self" label="배송비(원)" persistent-placeholder outlined dense hide-details />
                                    </v-flex>
                                </v-layout>
    
                                <v-layout v-if="item.code == 'order'" class="pa-2">
                                    <v-flex grow-shrink-0>
                                        <v-text-field v-model="setting.saleAmount" label="주문금액(원)" outlined dense hide-details persistent-placeholder />
                                    </v-flex>
                                    <v-flex grow-shrink-0>
                                        <v-layout align="center">
                                            <v-flex grow-shrink-0 class="px-2">이상 구매시</v-flex>
                                            <v-flex grow-shrink-0>
                                                <v-text-field v-model="setting.shippingPrice.gt" label="배송비(원)" outlined dense hide-details persistent-placeholder />
                                            </v-flex>
                                        </v-layout>
                                        <v-layout align="center" class="mt-2">
                                            <v-flex grow-shrink-0 class="px-2">미만 구매시</v-flex>
                                            <v-flex grow-shrink-0>
                                                <v-text-field v-model="setting.shippingPrice.lt" label="배송비(원)" outlined dense hide-details persistent-placeholder />
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="item.code == 'free'">
                                    <v-flex class="py-0 text-start">※ 해당 제품 구매시 무료배송으로 표시됩니다.</v-flex>
                                </v-layout>
                                <v-layout v-if="item.code == 'later'">
                                    <v-flex class="py-0 text-start">※ 해당 제품 구매시 착불배송으로 표시됩니다.</v-flex>
                                </v-layout>
                            </template>
                        </v-data-table>
                    </v-radio-group>
                </v-card-text>
            </v-card>
    
            <v-card class="mt-4">
                <v-card-title class="subtitle-2"><b>상품별 배송정책</b></v-card-title>
                <v-divider/>
                <v-card-text class="pa-0">
                        <v-data-table :items="shipping" item-key="code" :headers="shippingsHeaders" disable-sort disable-pagination hide-default-footer>
                            <template slot="item.shippingPrice" slot-scope="{item}">
                                <v-layout v-if="item.code == 'allFree'">
                                    <v-radio-group v-model="setting.freePolicyCode">
                                        <v-radio value="free" label="무료배송 상품과 함께 주문할 경우, 전체 배송비를 무료로합니다.">
                                        </v-radio>
                                        <v-radio value="free2" label="무료배송 상품과 함께 주문할 경우, 무료배송 상품을 제외한 상품은 배송비를 부과합니다.">
                                        </v-radio>
                                    </v-radio-group>
                                </v-layout>
                                <v-layout v-if="item.code == 'product'">
                                    <v-radio-group v-model="setting.productPolicyCode">
                                        <v-radio value="product" label="상품을 2개 이상 주문할 경우, 상품별 배송비와 기본 배송비를 합산한 금액을 배송비로 지정합니다.">
                                        </v-radio>
                                        <v-radio value="product2" label="상품을 2개 이상 주문할 경우, 상품별 배송비와 기본 배송 중 더 큰 배송비를 전체 배송비로 지정합니다.">
                                        </v-radio>
                                    </v-radio-group>
                                </v-layout>
                            </template>
                        </v-data-table>
                </v-card-text>
            </v-card>
    
            <v-card class="mt-4">
                <v-card-title class="subtitle-2"><b>지역할증 설정</b></v-card-title>
                <template v-for="island, index in islands">
                    <v-responsive :key="index">
                        <v-divider/>
                        <v-card-title>
                            <v-layout align-center>
                                <span class="subtitle-2"><b>{{ island.name }}</b></span>
                                <v-spacer/>
                                <v-flex grow-shrink-0><v-text-field v-model="setting.islandPrice[island.code]" :label="island.name + ' 할증비'" persistent-placeholder dense hide-details outlined class="d-inline-block ml-2" /></v-flex>
                            </v-layout>
                        </v-card-title>
                        <v-divider />
                        <v-data-table :items="island.areas" :headers="islandHeaders" :items-per-page="5" />
                    </v-responsive>
                </template>
            </v-card>
    
            <v-card class="mt-4">
                <v-card-title class="subtitle-2"><b>포인트 설정</b></v-card-title>
                <v-card-text>
                    <v-layout class="mx-n2">
                        <v-flex xs12 md6 class="px-2">
                            <v-text-field v-model="setting.pointPrice.join" label="회원가입 포인트" dense outlined hide-details suffix="원" />
                        </v-flex>
                    </v-layout>
                    <!-- <v-layout class="mt-4 mx-n2">
                        <v-flex xs12 md6 class="px-2">
                            <v-text-field v-model="setting.pointPercent.product" label="상품구매시 포인트" dense outlined hide-details suffix="%" />
                        </v-flex>
                        <v-flex xs12 md6 class="px-2">
                            <v-layout>
                                <v-text-field v-model="productPercent" label="포인트 일괄적용" dense outlined hide-details suffix="%" />
                                <v-btn color="primary" class="ml-2">적용</v-btn>
                            </v-layout>
                        </v-flex>
                    </v-layout> -->
                </v-card-text>
            </v-card>
        </console-body>


        <v-layout class="my-4">
            <v-btn color="primary" @click="save" class="mx-auto">저장</v-btn>
        </v-layout>

    </console-layout>
</template>

<script>
import api from "@/api";
import { mdiContentSave, mdiBasket, mdiFileDocumentOutline, mdiCashRemove, mdiTruck } from "@mdi/js";
import couriers from "@/assets/data/couriers.json";
import islands from "@/assets/data/islands.json";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";

export default {
    components: {
        NaverSmarteditor
    },
    data(){
        return {
            mdiContentSave,
            mdiBasket,
            mdiFileDocumentOutline,
            mdiCashRemove,
            mdiTruck,

            test: null,

            couriers,
            islands,

            setting: {
                _id: null,
                _store: null,

                courierCode: null,

                saleAmount: 0,
                shippingCode: null,
                shippingPrice: {
                    gt: 0,
                    lt: 0,
                    self: 0,
                },

                freeShipping: {
                    code: null
                },

                freePolicyCode: null,

                productShipping: {
                    code: null
                },

                productPolicyCode: null,

                islandPrice: {},

                pointPrice: {
                    join: 0,
                },

                pointPercent: {
                    product: 0
                }
            },

            productPercent: 0,

            islandHeaders: [
                { text: "우편번호", value: "postcode", width: 180 },
                { text: "주소", value: "address" },
            ],

            shippings: [
                { name: "무료배송", code: "free", icon: mdiCashRemove, color: "red lighten-3" },
                { name: "수신자 부담(착불)", code: "later", icon: mdiTruck, color: "light-green lighten-3"  },
                { name: "구매상품별", code: "self", icon: mdiBasket, color: "blue lighten-3" },
                { name: "주문가격별", code: "order", icon: mdiFileDocumentOutline, color: "orange lighten-3" },
            ],

            shipping: [
                { name: "무료배송 상품", code: "allFree", icon: mdiCashRemove, color: "red lighten-3" },
                { name: "상품별 배송비", code: "product", icon: mdiTruck, color: "light-green lighten-3"  },
            ],

            shippingsHeaders: [
                { text: "", value: "actions", width: 50 },
                { text: "정책명", value: "name", width: 200 },
                { text: "배송비", value: "shippingPrice" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { setting } = await api.console.shop.setting.get();
            this.setting = setting ? setting : this.setting;
        },
        async save(){
            this.setting._id ? await api.console.shop.setting.put(this.setting) : await api.console.shop.setting.post(this.setting);
            alert("저장되었습니다");
        }
    }
}
</script>